/**
 * TypingIndicator Component - Web Dashboard
 * Animated 3-dot indicator showing when user is typing
 *
 * Design: Golden Glow aesthetic with smooth CSS animations
 */



interface TypingIndicatorProps {
  isVisible: boolean;
  userName?: string;
}

export function TypingIndicator({ isVisible, userName }: TypingIndicatorProps) {
  if (!isVisible) return null;

  return (
    <div className="flex items-start gap-2 mb-4 animate-fade-in">
      {/* Avatar placeholder */}
      <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center">
        <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" fill="currentColor" viewBox="0 0 20 20">
          <path d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" />
        </svg>
      </div>

      {/* Typing bubble */}
      <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-2xl rounded-bl-sm px-4 py-3 shadow-sm">
        <div className="flex items-center gap-1">
          {/* Animated dots */}
          <span
            className="w-2 h-2 rounded-full bg-amber-500 animate-bounce"
            style={{ animationDelay: '0ms' }}
          />
          <span
            className="w-2 h-2 rounded-full bg-amber-500 animate-bounce"
            style={{ animationDelay: '150ms' }}
          />
          <span
            className="w-2 h-2 rounded-full bg-amber-500 animate-bounce"
            style={{ animationDelay: '300ms' }}
          />
        </div>
        {userName && (
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
            {userName} กำลังพิมพ์...
          </p>
        )}
      </div>
    </div>
  );
}

export default TypingIndicator;
